export default "__VITE_ASSET__c99a3caa__"